
import { ProductTrackingNumber } from "@/models/base";
import { StockLocationConfig } from "@/models/dossier-configs/stock-location";
import { DossierConfigService } from "@/services/dossier-config-service";
import { ProductService } from "@/services";
import { SaleEditRowState } from "@/utils/sale-edit/sale-edit-row-state";
import { SaleEditState } from "@/utils/sale-edit/sale-edit-state";
import Vue from "vue";

export default Vue.extend({
	data(){
		return {
			items: [] as ProductTrackingNumber[],
			endReached: false,
			fetching: false,
			inited: false
		};
	},
	props: {
		state: {
			type: Object as ()=>SaleEditState,
			required: true
		},
		rowEditState: {
			type: Object as ()=>SaleEditRowState,
			required: true
		}
	},
	computed: {
		title():string{
			if (!this.rowEditState.product) return "";
			return this.$ct("select-tracking-number-for-sku", {sku: this.rowEditState.product.Sku}).toString();
		},
		stockLocationConfig():StockLocationConfig{
			return DossierConfigService.getStockLocationConfig();
		}
	},
	methods: {
		getLocationsText(item:ProductTrackingNumber):string{
			let parts = [] as string[];
			for (let i = 1; i <= StockLocationConfig.MAX_ID; i++){
				let qty = (item as any)["Location" + i + "Qty"] as number;
				if (!qty) continue;
				parts.push(this.stockLocationConfig.getLocationName(i));
			}
			return parts.join(", ");
		},
		async fetchMore(){
			if (this.fetching) return;
			if (this.endReached) return;
			if (!this.rowEditState.product) return;
			try{
				this.fetching = true;
				let result = await ProductService.getTrackingNumbersByDate(this.rowEditState.product.ID, 500, this.items.length);
				if (result.length == 0){
					this.endReached = true;
					return;
				}
				this.items.push(...result);
			}catch(err){

			}
			this.fetching = false;
		},
		selectItem(item:ProductTrackingNumber){
			this.$emit("input", item.TrackingNumber);
			this.close();
		},
		close(){
			this.$emit("close");
		},
		onScroll(vueInstance:Vue){
			if (this.fetching || this.endReached) return;
			let el = vueInstance.$el as HTMLElement;
			let tableRect = el.getBoundingClientRect();
			let childRect = (el.lastChild as HTMLElement).getBoundingClientRect();


			let tableBottomY = tableRect.top + tableRect.height;
			if (childRect.top < (tableBottomY + 4000) && !this.fetching) {
				this.fetchMore();
			}
		}
	},
	async mounted(){
		await this.fetchMore();
		this.inited = true;
	},
	i18nEx: {
		componentPrefix: "components.sales"
	}
});
